import Cookie from '@alife/alpha-cookie';
import queryString from 'query-string';
import fetchJsonp from 'fetch-jsonp';
import 'whatwg-fetch';
import { commonDot } from '../components/dots';
import { httpResponseType } from './typing';
import { LOGIN_LINK } from './login';
// 使用文档: https://yuque.antfin.com/fg0y0t/rax3qv/xifnzg

interface dotParamsType {
  apiName: string;
  code: string | number;
  httpstatus?: string | number;
  time: number;
  msg?: string;
}

const apiDot = (params: dotParamsType) => {
  // 黄金令箭上报 api打点, 注意apiName的划分
  commonDot({
    goldKey: '/sc.dser.saas.api', // 独立令箭名，单独监控
    params: {
      scene: '',
      action: '',
      ...params,
    },
  });
};

/*
注意：返回就是一个Promise， 不用自己再去构造一个 new Promise对象了
Demo:
request('//dropshipping.alibaba.com/saas/product/push_product', {
        method: 'POST',
        body: {
          ...body,
          _tb_token_: Cookie.get('_tb_token_'),
        },
      })
*/

// 处理回调
const processResponse = (props: {
  bodydata: any;
  apiDotParams: dotParamsType;
  shouldLoginCheck: boolean;
  resolve: (value: httpResponseType) => void;
  reject: (reason: Error) => void;
}) => {
  const { bodydata, apiDotParams, shouldLoginCheck, resolve, reject } = props;

  const code = bodydata?.code ? Number(bodydata.code) : '';
  apiDotParams.code = bodydata?.code || '';
  apiDotParams.msg = `${encodeURIComponent(bodydata?.message || '')}`;
  if (code !== 200) {
    // 增加跳过登录判断
    if (shouldLoginCheck === true && code === 401) {
      reject(bodydata);
      location.assign(LOGIN_LINK);
    } else {
      // 文件下载
      if (bodydata.type?.indexOf('application/') > -1) {
        apiDotParams.code = '200';
      }
      resolve(bodydata);
    }
  } else {
    resolve(bodydata);
  }

  apiDot(apiDotParams);
};

const request = (url: string, options?: any, manageResponse?: (body: any) => any) => {
  // 请求参数处理
  const defaultOptions = {
    credentials: 'include',
  };

  const ctoken = Cookie.get('_tb_token_');
  const newOptions = { ...defaultOptions, ...options };

  if (newOptions.method === 'POST' || newOptions.method === 'PUT') {
    newOptions.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      // 'x-csrf-token': ctoken, // 通过url参数传递
      ...newOptions.headers,
    };

    newOptions.body = JSON.stringify({ ...newOptions.body });
  }
  let finalURL = '';

  const query = {
    _tb_token_: ctoken,
    ...options?.query,
  };
  if (options?.noCtoken) {
    delete query._tb_token_;
  }
  let shouldLoginCheck = true;
  if (options?.shouldLoginCheck === false) {
    shouldLoginCheck = false;
  }

  finalURL = `${url}${url.indexOf('?') > 0 ? '&' : '?'}${queryString.stringify(query)}`;

  const apiName = url.split('?')[0];
  const startTime = new Date().getTime();
  return new Promise(
    (resolve: (value: httpResponseType) => void, reject: (reason: Error) => void) => {
      window
        .fetch(finalURL, newOptions)
        .then(async (response) => {
          const apiDotParams: dotParamsType = {
            apiName,
            code: '',
            httpstatus: response.status,
            time: new Date().getTime() - startTime,
          };

          if (response.status === 200) {
            const bodydata: any = manageResponse
              ? await manageResponse(response)
              : await response.json();

            processResponse({
              bodydata,
              apiDotParams,
              shouldLoginCheck,
              resolve,
              reject,
            });
          } else {
            apiDot(apiDotParams);
            reject(new Error(`httpstatus=${response.status}`));
          }
        })
        .catch((err) => {
          apiDot({
            apiName,
            code: 'network_error',
            time: new Date().getTime() - startTime,
          });
          reject(err);
        });
    },
  );
};

/*
注意：返回就是一个Promise， 不用自己再去构造一个 new Promise对象了
Demo:
jsonp(`https://connectkeyword.alibaba.com/lenoIframeJson.htm`, {
    query: params,
  });
*/
const jsonp = (url: string, options?: any) => {
  const apiName = url.split('?')[0];
  const startTime = new Date().getTime();
  let finalURL = '';
  if (options && options.query) {
    finalURL = `${url}?${queryString.stringify(options.query)}`;
  } else {
    finalURL = url;
  }
  return new Promise(
    (resolve: (value: httpResponseType) => void, reject: (reason: Error) => void) => {
      fetchJsonp(finalURL, {
        timeout: 3000,
        ...options,
      })
        .then(async (response: any) => {
          const bodydata: any = await response.json();
          const apiDotParams: dotParamsType = {
            apiName,
            code: bodydata.code,
            time: new Date().getTime() - startTime,
          };

          processResponse({
            apiDotParams,
            bodydata,
            shouldLoginCheck: options?.checkLogin === true,
            resolve,
            reject,
          });
        })
        .catch((ex: Error) => {
          apiDot({
            apiName,
            code: 'network_error',
            time: new Date().getTime() - startTime,
          });
          reject(ex);
        });
    },
  );
};

const openservice = (serviceName: string, params?: { [key: string]: string | number }) => {
  const resultParams = {
    fsb: 'y',
    IndexArea: 'product_en',
    appKey: 'a5m1ismomeptugvfmkkjnwwqnwyrhpb1',
    appName: 'magellan',
    ...params,
  };
  const paramStr = Object.keys(resultParams)
    .reduce((allArr: string[], currKey) => {
      allArr.push(`${currKey}=${resultParams[currKey]}`);
      return allArr;
    }, [])
    .join('&');

  const url = `//open-s.alibaba.com/openservice/${serviceName}?${paramStr}`;

  return request(url, {});
};

export { request, jsonp, openservice, apiDot };
